import { TutorialId } from '../interfaces';
import { useTutorial } from './context';

/**
 * Returns the ids of tutorials the user has fully completed (persisted in
 * localStorage, so this reflects prior sessions too).
 */
export const useCompletedTutorials = (): TutorialId[] => {
  const { completedTutorialIds } = useTutorial();

  return completedTutorialIds;
};
